module.exports = __webpack_public_path__ + "static/media/02-banner-02-santa-fe@2x.d5a2159b.jpg";